import { render } from "./skeleton-com.vue?vue&type=template&id=780a5780&scoped=true"
import script from "./skeleton-com.vue?vue&type=script&lang=js"
export * from "./skeleton-com.vue?vue&type=script&lang=js"

import "./skeleton-com.vue?vue&type=style&index=0&id=780a5780&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780a5780"]])

export default __exports__